export default __webpack_public_path__ + "static/media/bed09.6e7fd134.png";